import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useSimplifiedNav } from '@sorare/core/src/hooks/commonGame/useSimplifiedNav';
import { useLifecycle } from '@sorare/core/src/hooks/useLifecycle';

export const useMissionsPreferredRarity = () => {
  const { sport } = useSportContext();
  const { lifecycle } = useLifecycle();
  const { showSimplifiedNav } = useSimplifiedNav(sport);

  if (showSimplifiedNav) {
    return Rarity.common;
  }

  const preferredSportRarity = lifecycle?.missionsRarityFilter?.[sport];

  return typeof preferredSportRarity === 'string'
    ? preferredSportRarity
    : Rarity.common;
};
